// extracted by mini-css-extract-plugin
export default {"container":"EditNavigationPage_container__vGc8X"};